import { BaseModel } from './BaseModel';

export class GitWebhook extends BaseModel {
    public id = -1;
    public provider = 'github';
    public directory = '/';
    public branch: string | null = null;
    public resetHard = false;
    public receiverUrl = '';
    public lastTriggeredAt: string | null = null;
    public lastError: string | null = null;
    public createdAt: string | null = null;
    /** Only populated on the create response; never echoed again. */
    public secret?: string;
}
